// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HkpG","field":"styles_field__8-hFG","fieldCol":"styles_fieldCol__3faKB","diffCol":"styles_diffCol__2jeTq","diff":"styles_diff__2T3mv"};